import { Component, OnInit ,Renderer} from '@angular/core';

@Component({
  selector: 'app-user-sidemenu',
  templateUrl: './usersidemenu.component.html'
})
export class UserSideMenuComponent implements OnInit {

  constructor(private render:Renderer) { }
  
  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/common/usersidemenu.component.ts